const firebaseConfig = {
  apiKey: "AIzaSyDtfqr6LgGjL56V1Oa3C5MWZ18iB5yxd6Q",
  authDomain: "creative-agency-71f9c.firebaseapp.com",
  databaseURL: "https://creative-agency-71f9c.firebaseio.com",
  projectId: "creative-agency-71f9c",
  storageBucket: "creative-agency-71f9c.appspot.com",
  messagingSenderId: "764559310734",
  appId: "1:764559310734:web:eff1339b6a9eab2edaaedf",
};

export default firebaseConfig;
